import { FC } from 'react'
import { Stack } from '@mui/material'
import { InductionDialogs } from './InductionDialogs'
import { AdvAnnouncementAlert } from './AdvAnnouncementAlert'
import { InformationForNewUsers } from './InformationForNewUsers'
import { WebPushAlert } from './WebPushAlert'
import { InstagramGrowthCard } from './InstagramGrowthCard'
import { Tutorial } from './Tutorial'
import { PageContainer } from '~/components/common/PageContainer'
import { TodoOfferAlert } from './TodoOfferAlert'
import { TicketsExpireSoonAlert } from './TicketsExpireSoonAlert'
import { CampaignInsight } from './campaignInsight'

export const HomeContent: FC = () => {
  return (
    <PageContainer>
      <InductionDialogs />
      <Stack gap={3}>
        <Stack gap={1}>
          <WebPushAlert />
          <TodoOfferAlert />
          <TicketsExpireSoonAlert />
          <AdvAnnouncementAlert />
        </Stack>
        <InformationForNewUsers />
        <CampaignInsight />
        <InstagramGrowthCard />
        <Tutorial />
      </Stack>
    </PageContainer>
  )
}
